import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import type { GeneratorType } from '../../../types/game-types';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { farmerReducer } from './farmer.reducer';
import { garrisonReducer } from './garrison.reducer';
import { academyReducer } from './academy.reducer';
import { guildReducer } from './guild.reducer';
import { councilReducer } from './council.reducer';
import { nexusReducer } from './nexus.reducer';
import { congressReducer } from './congress.reducer';
import { lumberjackReducer } from './lumberjack.reducer';
import { minerReducer } from './miner.reducer';
import { outpostReducer } from './outpost.reducer';
import { forestReducer } from './forest.reducer';
import { seminaryReducer } from './seminary.reducer';
import { troupeReducer } from './troupe.reducer';
import { theaterReducer } from './theater.reducer';
import { collegeReducer } from './college.reducer';
import { clericReducer } from './cleric.reducer';
import { inspirationReducer } from './inspiration.reducer';
import { unitStats } from '../../../stats';
import { wizardReducer } from './wizard.reducer';
import { thiefReducer } from './thief.reducer';
import { useDragonHealthStore } from '../../zustand/useDragonHealthStore';

// const TEMP_REDUCER = (state: GUIGameState) => {
//   return state;
// };

const baseReducer = (scratch: StatsSnapshot, generatorType: GeneratorType) => {
  const stats = unitStats[generatorType];

  const isCritical = Math.random() * 100 < (stats.criticalChance ?? 0);
  const damage = isCritical ? (stats.criticalDamage ?? 0) : (stats.damagePerTick ?? 0);

  const nextHealth = Math.max(0, useDragonHealthStore.getState().dragonHealth - damage);
  useDragonHealthStore.getState().setHealth(nextHealth);
  const goldGain =
    (isCritical ? (stats.criticalDamage ?? 1) / (stats.damagePerTick ?? 1) : 1) * (stats.goldGeneration ?? 0);
  useCurrencyStore.getState().addGold(goldGain);

  const currency = useCurrencyStore.getState();
  const nextInspiration = inspirationReducer(
    currency.inspiration,
    stats.inspirationGeneration ?? 0,
    scratch.upgrades,
  );
  useCurrencyStore.getState().sync({ inspiration: nextInspiration });
};

export const generatorReducers: Record<
  GeneratorType,
  (scratch: StatsSnapshot, generatorType: GeneratorType) => void
> = {
  warrior: baseReducer,
  wizard: wizardReducer,
  elf: baseReducer,
  garrison: garrisonReducer,
  academy: academyReducer,
  outpost: outpostReducer,
  council: councilReducer,
  nexus: nexusReducer,
  forest: forestReducer,
  thief: thiefReducer,
  bard: baseReducer,
  cleric: clericReducer,
  guild: guildReducer,
  troupe: troupeReducer,
  seminary: seminaryReducer,
  congress: congressReducer,
  theater: theaterReducer,
  college: collegeReducer,

  farmer: farmerReducer,
  lumberjack: lumberjackReducer,
  miner: minerReducer,

  catapult: baseReducer,
  // builder: TEMP_REDUCER,
  // blacksmith: TEMP_REDUCER,
} as const;
